/**
 * ReferralAlreadyMemberModal.jsx — Affiché quand un utilisateur DÉJÀ connecté arrive sur un
 * lien de parrainage (/?ref=). Il ne peut pas être parrainé (compte existant), donc au lieu
 * d'ouvrir la modal de connexion (qui bouclait), on l'invite à devenir parrain à son tour.
 *
 * §12sexies croix cerclée · §20 tokens · §64 English · §65 earnicoins · §89 pas de tiret cadratin
 * §96 composant poli par défaut (bloc dédié, magenta sur la valeur clé, micro-interactions).
 */
import React from 'react';
import {
  ModalHeader, ModalHeaderTitle, ModalCloseBtn, ModalBody, ModalIconBadge,
} from './ModalDA';
import { ModalShell } from './ModalShell';
import { CtaButton, GhostButton } from './daComponents';
import styled from 'styled-components';
import { COLORS, FONTS } from './theme';

const Description = styled.div`
  font-family: ${FONTS.body};
  font-size: 0.9375rem;
  color: ${COLORS.ink};
  line-height: 1.55;
  margin: 0 0 1.5rem;
`;

const Highlight = styled.strong`
  color: ${COLORS.accent};
`;

const Actions = styled.div`
  display: flex;
  gap: 0.625rem;
  justify-content: center;
`;

/**
 * @param {object}   props
 * @param {boolean}  props.open
 * @param {function} props.onClose
 * @param {function} props.onInvite  - Appelé quand l'utilisateur veut inviter (ouvre la modal Invite).
 */
export default function ReferralAlreadyMemberModal({ open, onClose, onInvite }) {
  if (!open) return null;

  return (
    <ModalShell isOpen={open} onClose={onClose} $width="26rem" aria-label="Already a member">
      <ModalHeader>
        <ModalHeaderTitle>You're already a member</ModalHeaderTitle>
        <ModalCloseBtn onClick={onClose} aria-label="Close">✕</ModalCloseBtn>
      </ModalHeader>

      <ModalBody>
        <ModalIconBadge $bg={COLORS.accentSoft} $border $size="4rem" aria-hidden="true">
          <span style={{ fontSize: '1.5rem' }}>🎉</span>
        </ModalIconBadge>

        <Description>
          Good news, your <Highlight>Earniverse</Highlight> account already exists, so this invite
          link has nothing more to unlock for you. But you can join the referral program yourself:
          invite your friends to Earniverse, the AAA VR metaverse, and its collectibles marketplace
          <Highlight> Earnimarket</Highlight>, and you both earn <Highlight>earnicoins</Highlight>.
        </Description>

        <Actions>
          <GhostButton onClick={onClose}>Maybe later</GhostButton>
          <CtaButton onClick={onInvite}>Invite friends</CtaButton>
        </Actions>
      </ModalBody>
    </ModalShell>
  );
}
